// Shared heatmap utilities used by main scanner and ScanLabPage.

export function heatColor(t, palette) {
  let r, g, b;
  if (palette === "classic") {
    if (t < 0.25)      { r = 0;   g = Math.round(t*4*255);             b = 255; }
    else if (t < 0.5)  { r = 0;   g = 255;                             b = Math.round((1-(t-0.25)*4)*255); }
    else if (t < 0.75) { r = Math.round((t-0.5)*4*255); g = 255;      b = 0; }
    else               { r = 255; g = Math.round((1-(t-0.75)*4)*255); b = 0; }
  } else if (palette === "hot") {
    if (t < 0.33)      { r = Math.round(t*3*255);  g = 0;                   b = 0; }
    else if (t < 0.66) { r = 255; g = Math.round((t-0.33)*3*255);          b = 0; }
    else               { r = 255; g = 255; b = Math.round((t-0.66)*3*255); }
  } else if (palette === "cool") {
    r = Math.round((1-t)*255);
    g = Math.round((1-t)*200);
    b = 255;
  } else {
    const v = Math.round(t * 255);
    r = v; g = v; b = v;
  }
  return [r, g, b];
}

// Percentile normalization (5–95%): cuts dark edge outliers and bright noise,
// stretches the real pressure range across the full colour spectrum.
export function generateHeatmap(base64, { opacity = 0.85, bgThreshold = 25, invertMapping = false, outputBg = "white", palette = "classic" }) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const W = img.naturalWidth, H = img.naturalHeight;
      const src = document.createElement("canvas");
      src.width = W; src.height = H;
      const sctx = src.getContext("2d");
      sctx.drawImage(img, 0, 0);
      const { data: px } = sctx.getImageData(0, 0, W, H);

      const lums = new Float32Array(W * H);
      const footLums = [];
      for (let i = 0; i < px.length; i += 4) {
        const lum = px[i] * 0.299 + px[i+1] * 0.587 + px[i+2] * 0.114;
        lums[i / 4] = lum;
        if (lum > bgThreshold) footLums.push(lum);
      }
      footLums.sort((a, b) => a - b);
      const p5  = footLums[Math.floor(footLums.length * 0.05)] ?? 0;
      const p95 = footLums[Math.floor(footLums.length * 0.95)] ?? 255;
      const range = Math.max(1, p95 - p5);

      const out = document.createElement("canvas");
      out.width = W; out.height = H;
      const octx = out.getContext("2d");
      octx.fillStyle = outputBg === "white" ? "#ffffff" : "#080808";
      octx.fillRect(0, 0, W, H);

      const overlay = document.createElement("canvas");
      overlay.width = W; overlay.height = H;
      const ovctx = overlay.getContext("2d");
      const hd = ovctx.createImageData(W, H);
      const hp = hd.data;

      for (let i = 0; i < px.length; i += 4) {
        const lum = lums[i / 4];
        if (lum <= bgThreshold) { hp[i+3] = 0; continue; }
        let t = Math.max(0, Math.min(1, (lum - p5) / range));
        if (invertMapping) t = 1 - t;
        const [r, g, b] = heatColor(t, palette);
        hp[i] = r; hp[i+1] = g; hp[i+2] = b; hp[i+3] = Math.round(opacity * 255);
      }
      ovctx.putImageData(hd, 0, 0);
      octx.drawImage(overlay, 0, 0);
      resolve(out.toDataURL("image/jpeg", 0.92));
    };
    img.src = base64;
  });
}
